import angular from 'angular';
import AdminReportsPageComponent from './admin-reports-page-component';

export default angular.module('admin-reports-page', []).component('adminReportsPage', new AdminReportsPageComponent());



// WEBPACK FOOTER //
// ./src/modules/admin-reports/components/admin-reports-page/admin-reports-page-module.js